  <p-card class="w-full p-2 m-4 md:w-6/12">
    <ng-template #title>Payment Methods</ng-template>
<div *ngIf="isLoading">
  <h2>Loading ...... Please Wait</h2>
</div>
<div *ngIf="!isLoading">
    <div *ngIf="!payment_methods() || payment_methods()!.length === 0">
      No payment methods found
    </div>
    <div *ngIf="payment_methods() && payment_methods()!.length > 0">
      <table>
        <thead>
          <tr>
            <th>Card Type</th>
            <th>Card Last 4</th>
            <th>Expiry Date</th>
            <th>Default</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of payment_methods()">
            <td>{{ item.card_brand }}</td>
            <td>{{ item.last4 }}</td>
            <td>{{ item.card_expiry_month }}/{{ item.card_expiry_year }}</td>
            <td>{{ item.isDefault | boolToText }}</td>
            <td>
              <p-button
                (click)="menuClicked(item); menu.toggle($event)"
                icon="pi pi-ellipsis-v" />
            </td>
          </tr>
        </tbody>
      </table>
      <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
    </div>
    </div>
    <ng-template #footer>
      <div class="flex flex-wrap w-full p-4 mt-4 font-semibold">
        <p-button
          label="Add Card"
          pRipple
          icon="pi pi-wallet"
          class="w-full p-4 m-2 text-center rounded-md lg:w-2/12 bg-primary-500"
          (onClick)="addPaymentMethod()" />
      </div>
    </ng-template>
  </p-card>
